import type { FC } from 'react'
import React from 'react'
import { CommonLink } from '@frontend/pole-ui/lib/components/CommonLink'
import classNames from 'classnames'
import { Checkbox } from '@/components/ui/fields'
import { useData } from '@/logic/data'
import { getLegalDocumentUrl } from '@/logic/legalDocuments/helpers'
import type { TLegalDocuments } from '@/types/legalDocuments'
import { ELegalDocumentType } from '@/types/legalDocuments'
import { formatLocalizedString } from '@/utils/formatUtils'
import { useDeviceType } from '@/utils/hooks/useDeviceType'
import { messages } from './messages'
import type { IPolicyAgreementProps } from './types'
import './styles.scss'

const PolicyAgreement: FC<IPolicyAgreementProps> = props => {
  const { isRequired, isDarkBackground = false } = props

  const { data: legalDocuments = [] } = useData<TLegalDocuments>('legalDocuments')
  const { isMobile } = useDeviceType()

  return (
    <div className="policyAgreement">
      <Checkbox id="agreement" name="agreement" isRequired={isRequired} isMobile={isMobile} labelTextClassName="policyAgreement__labelText">
        <div>
          {formatLocalizedString(messages.agreement.text, {
            agreement: (
              <CommonLink
                url={getLegalDocumentUrl(legalDocuments, ELegalDocumentType.personalDataConsent)}
                shouldOpenInNewWindow
                className={classNames('underline underline_green color_green', {
                  'underline_white color_white policyAgreement__link--white': isDarkBackground,
                })}
              >
                {messages.agreement.agreement}
              </CommonLink>
            ),
            policy: (
              <CommonLink
                url={getLegalDocumentUrl(legalDocuments, ELegalDocumentType.registrationPolicy)}
                shouldOpenInNewWindow
                className={classNames('underline underline_green color_green', {
                  'underline_white color_white policyAgreement__link--white': isDarkBackground,
                })}
              >
                {messages.agreement.policy}
              </CommonLink>
            ),
          })}
        </div>
      </Checkbox>
    </div>
  )
}

export default PolicyAgreement
